import * as scheduleApi from '@/api/schedule';
import * as mediaContentsApi from '@/api/mediaContents';
import * as waitMediaContentsApi from '@/api/waitMediaContents';
import * as _ from 'lodash';

const calculateWaitFileDuration = (waitFile) => {
    if (!_.isEmpty(waitFile)) {
        return waitFile.raw_duration / (60 * 1000);
    }
    return 0;
};

const sumFileDuration = (fileDuration, waitFileDuration) => {
    let numberFileDuration = 0;
    let numberWaitFileDuration = 0;

    if (typeof fileDuration === 'number') {
        numberFileDuration = fileDuration;
    }

    if (typeof waitFileDuration === 'number') {
        numberWaitFileDuration = waitFileDuration;
    }

    return numberFileDuration + numberWaitFileDuration;
};

export default {
    namespaced: true,
    state: {
        registerModalShow: false,
        editable: true,
        program: {
            id: 0,
            live_media_channel_id: '',
            live_media_channel_hidden_at: null,
            live_media_channel_title: '',
            title: '',
            wait_file: null,
            wait_file_duration: 0,
            files: [],
            start: null,
            end: null,
            file_duration: 0,
            meta: {
                errors: {},
            },
        },
        submitProcess: false,
        pickDateTime: null,
        editBeforeData: {
            program: {
                id: 0,
                live_media_channel_id: '',
                live_media_channel_hidden_at: null,
                live_media_channel_title: '',
                title: '',
                wait_file: null,
                wait_file_duration: 0,
                files: [],
                start: null,
                end: null,
                file_duration: 0,
                meta: {
                    errors: {},
                },
            },
            pickDateTime: null,
        },
        mediaContents: [],
        waitMediaContents: [],
    },
    getters: {
        registerModalShow: state => state.registerModalShow,
        program: state => state.program,
        pickDateTime: state => state.pickDateTime,
        submitProcess: state => state.submitProcess,
        editable: state => state.editable,
        editBeforeData: state => state.editBeforeData,
        mediaContents: state => state.mediaContents,
        waitMediaContents: state => state.waitMediaContents,
    },
    mutations: {
        setRegisterModalShow(state, payload) {
            state.registerModalShow = payload;
        },
        setProgramChannel(state, { id, hided_at, title }) {
            state.program.live_media_channel_id = id;
            state.program.live_media_channel_hidden_at = hided_at;
            state.program.live_media_channel_title = title;
        },
        setWaitFile(state, payload) {
            state.program.wait_file = payload;
            if (!state.program.wait_file) {
                state.program.wait_file_duration = 0;
            }
        },
        setWaitFileDuration(state, payload) {
            state.program.wait_file_duration = payload;
            const fileDuration = state.program.files.map(el => el.transcoding_file.raw_duration).reduce((prev, current) => prev + current, 0);
            state.program.file_duration = sumFileDuration(fileDuration, state.program.wait_file_duration * 1000 * 60);
        },
        setProgramTitle(state, payload) {
            state.program.title = payload;
        },
        addProgramFile(state, payload) {
            state.program.files.push(payload);
            const fileDuration = state.program.files.map(el => el.transcoding_file.raw_duration).reduce((prev, current) => prev + current, 0);
            state.program.file_duration = sumFileDuration(fileDuration, state.program.wait_file_duration * 1000 * 60);
        },
        setProgramFile(state, payload) {
            state.program.files = payload;
            const fileDuration = state.program.files.map(el => el.transcoding_file.raw_duration).reduce((prev, current) => prev + current, 0);
            state.program.file_duration = sumFileDuration(fileDuration, state.program.wait_file_duration * 1000 * 60);
        },
        setPickDateTime(state, payload) {
            state.pickDateTime = payload;
        },
        setProgramMetaErrors(state, payload) {
            state.program.meta.errors = payload;
        },
        setEditProgram(state, payload) {
            // //
            const {
                live_program_id,
                live_media_channel,
                ongoing,
                finished,
                start,
                end,
                files,
                wait_file,
                title,
            } = payload;

            const fileDuration = files.map(el => el.transcoding_file.raw_duration).reduce((prev, current) => prev + current, 0);

            state.editable = ongoing === 0 && finished === 0;

            const editData = {
                id: live_program_id,
                live_media_channel_id: live_media_channel.id,
                live_media_channel_hidden_at: live_media_channel.hided_at,
                live_media_channel_title: live_media_channel.title,
                title,
                wait_file: !_.isEmpty(wait_file) ? wait_file : null,
                wait_file_duration: calculateWaitFileDuration(wait_file),
                files: [...files],
                file_duration: sumFileDuration(fileDuration, wait_file.raw_duration),
                start,
                end,
                meta: {
                    errors: {},
                },
            };

            const editPickTime = new Date(start);

            state.program = { ...editData };
            state.editBeforeData.program = { ...editData };

            state.pickDateTime = editPickTime;
            state.editBeforeData.pickDateTime = editPickTime;
        },
        clearProgram(state) {
            state.editable = true;
            state.program = {
                id: 0,
                live_media_channel_id: '',
                live_media_channel_hidden_at: null,
                live_media_channel_title: '',
                title: '',
                wait_file: null,
                wait_file_duration: 0,
                files: [],
                start: null,
                end: null,
                file_duration: 0,
                meta: {
                    errors: {},
                },
            };
            state.pickDateTime = null;

            state.editBeforeData = {
                program: {
                    id: 0,
                    live_media_channel_id: '',
                    live_media_channel_hidden_at: null,
                    live_media_channel_title: '',
                    title: '',
                    wait_file: null,
                    wait_file_duration: 0,
                    files: [],
                    start: null,
                    end: null,
                    file_duration: 0,
                    meta: {
                        errors: {},
                    },
                },
                pickDateTime: null,
            };
        },
        clearEditBeforeData(state) {
            state.editBeforeData = {
                program: {
                    id: 0,
                    live_media_channel_id: '',
                    live_media_channel_hidden_at: null,
                    live_media_channel_title: '',
                    title: '',
                    wait_file: null,
                    wait_file_duration: 0,
                    files: [],
                    start: null,
                    end: null,
                    file_duration: 0,
                    meta: {
                        errors: {},
                    },
                },
                pickDateTime: null,
            };
        },

        setEditable(state, payload) {
            state.editable = payload;
        },
        setSubmitProcess(state, payload) {
            state.submitProcess = payload;
        },
        setMetaErrors(state, payload) {
            state.program.meta.errors = payload;
        },
        setCopySchedule(state, payload) {
            const {
                title,
                live_media_channel_id,
                live_media_channel_title,
                live_media_channel_hidden_at,
                wait_file,
                wait_file_duration,
                files,
                file_duration,
            } = payload;

            state.program = {
                id: 0,
                live_media_channel_id,
                live_media_channel_hidden_at,
                live_media_channel_title,
                title: `${title} 복제본`,
                wait_file,
                wait_file_duration,
                files,
                start: null,
                end: null,
                file_duration,
                meta: {
                    errors: {},
                },
            };

            state.editable = true;
        },
        setMoveFilesItem(state, payload) {
            const {
                beforeIndex,
                afterIndex,
            } = payload;

            const cronFiles = [...state.program.files];
            const item = cronFiles.splice(beforeIndex, 1);

            cronFiles.splice(afterIndex, 0, item[0]);

            state.program.files = cronFiles;
        },
        setMediaContents(state, payload) {
            state.mediaContents = payload;
        },
        setWaitMediaContents(state, payload) {
            state.waitMediaContents = payload;
        },
    },

    actions: {
        async fetchSchedule({ getters, commit }, programId) {
            const response = await scheduleApi.fetchSchedule(programId);

            commit('setEditProgram', response.data.data);
        },
        async createSchedule({ getters }) {
            const form = {
                start_date: getters.pickDateTime,
                title: getters.program.title,
                files: getters.program.files,
                file_duration: getters.program.file_duration,
                wait_file: getters.program.wait_file,
                wait_file_duration: getters.program.wait_file_duration,
            };

            await scheduleApi.createSchedule(getters.program.live_media_channel_id, form);
        },

        async updateSchedule({ getters }) {
            const form = {
                start_date: getters.pickDateTime,
                title: getters.program.title,
                files: getters.program.files,
                file_duration: getters.program.file_duration,
                wait_file: getters.program.wait_file,
                wait_file_duration: getters.program.wait_file_duration,
            };

            await scheduleApi.updateSchedule(getters.program.live_media_channel_id, getters.program.id, form);
        },

        async removeSchedule({ getters }) {
            await scheduleApi.removeSchedule(getters.program.live_media_channel_id, getters.program.id);
        },

        async fetchMediaContents({ commit }) {
            try {
                const params = {
                    only_selectable: 1,
                    not_paginate: 1,
                };
                const response = await mediaContentsApi.fetchMediaContents(params);
                commit('setMediaContents', response.data.data);
            } catch (e) {
                commit('setMediaContents', []);
            }
        },

        async fetchWaitMediaContents({ commit }) {
            try {
                const params = {
                    only_selectable: 1,
                    not_paginate: 1,
                };
                const response = await waitMediaContentsApi.fetchWaitMediaContents(params);
                commit('setWaitMediaContents', response.data.data);
            } catch (e) {
                commit('setWaitMediaContents', []);
            }
        },
    },
};
